// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileIsBlocked":"jb_a bht_ea bht_ti"};